let navigateFunc = null;

export const setNavigate = (navigate) => {
  navigateFunc = navigate;
};

export const navigateFunction = (path) => {
  if (navigateFunc) navigateFunc(path);
};
